import {NgModule} from "@angular/core";
import {ResumeComponent} from "./resume.component";
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {ResumeRoutingModule} from "./resume-routing.module";
import { ProgressBarsComponent } from './progress-bars.component';

@NgModule({
  declarations: [
    ResumeComponent,
    ProgressBarsComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ResumeRoutingModule
  ],
  providers:[],
  exports: [ResumeComponent]
})

export class ResumeModule {}



// WEBPACK FOOTER //
// ./src/app/resume/resume.module.ts